import type { ComponentRenderProps } from './ComponentRegistry';
import type { DraggedElementData, DroppedElement, DroppedItemData } from './types';
import { itemKey } from './types';

export function getDroppedItemData({
  item,
  index,
  instanceId,
}: {
  item: DroppedElement;
  index: number;
  instanceId: symbol;
}): DroppedItemData {
  return {
    [itemKey]: true,
    item,
    index,
    instanceId,
  };
}

export function isDroppedItemData(data: Record<string | symbol, unknown>): data is DroppedItemData {
  return data[itemKey] === true;
}

export function isDraggedElementData(
  data: Record<string | symbol, unknown>
): data is DraggedElementData {
  return (
    typeof data === 'object' &&
    data !== null &&
    typeof data.id === 'string' &&
    typeof data.label === 'string' &&
    typeof data.type === 'string' &&
    typeof data.component === 'string'
  );
}

// Helper to extract common FocusedLabelEditor props
export function getFocusedEditorProps({
  element,
  value,
  onValueChange,
  onBottomSectionValueChange,
  bottomSectionConfig,
  bottomSectionValues,
}: ComponentRenderProps) {
  return {
    element,
    value,
    onValueChange,
    onBottomSectionValueChange,
    bottomSectionConfig,
    bottomSectionValues,
  };
}

// Reusable editable-props helper (no coercions; keep them inline at call sites)
export function getEditableComponentProps(props: ComponentRenderProps) {
  const { element, value: label, renderedValue, onRenderedValueChange: onChange } = props;

  return {
    label: label || element.label,
    isRequired: props.isRequired,
    isReadOnly: props.isReadOnly || !onChange,
    helperContent: props.helperContent,
    // pass through the raw renderedValue by default; callers can override inline
    value: renderedValue,
    onRenderedValueChange: onChange ? (value: string) => onChange(element.id, value) : undefined,
  };
}
